import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: theme.spacing(3),
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  button: {
    alignSelf: 'flex-start',
  },
}));
